<div class="mat-body text-center">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>

    <i class="icon-exclamation blue-icon-exclamation mb-3"></i>

    <p class="mat-subheading-2 text-left mb-3">{{ 'dialog.validate-client-notifications'|translate }}</p>
    <ul class="text-left mb-5">
        <ng-template ngFor let-notification [ngForOf]="data">
            <li>{{ notification.reason }}</li>
        </ng-template>
    </ul>

    <div class="row justify-content-center">
        <div class="col-12 col-sm-5 mt-3 mt-sm-0">
            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [mat-dialog-close]="true">
                <span>{{ 'general.accept'|translate }}</span>
            </button>
        </div>
    </div>
</div>
